import { formatTime } from "lib/format-time"
import { sanitizeAmendsHtml } from "../../project/amends/lib/sanitize-amends-html"
import { stripBlacklistedFontStyles } from "./strip-blacklisted-font-styles"
import { removeEmptyListItems } from "./remove-empty-list-items"

export { stripBlacklistedFontStyles }

export function sanitizePdfHtml(value) {
    const sanitized = removeEmptyListItems(sanitizeAmendsHtml(value))
    if (sanitized === "") return ""
    return stripBlacklistedFontStyles(sanitized)
}

// Publish dates are stored as UTC-midnight strings to preserve the selected calendar day, so
// they must be formatted in UTC — local-timezone formatting can shift them back a day.
export function formatPublishedDate(value) {
    return formatDate(value, { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" })
}

export function formatAuthorNoteDate(value) {
    return formatDate(value, {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    })
}

export function formatFrequencyLabel(frequency = {}) {
    const period = frequency?.period
    const interval = frequency?.interval
    if (!period || !interval) return "-"

    const shortLabel = `${interval}${String(period).charAt(0)}`
    const longLabel = `Every ${shortLabel}`
    return { shortLabel, longLabel }
}

export function formatMinutesLabel(minutes) {
    if (minutes == null) return "-"
    return `${minutes} mins`
}

export function formatTaskDurationLabel(minutes) {
    if (minutes == null) return "-"
    return formatTime(Math.round(minutes))
}

export function formatValueOrDash(value) {
    return value == null || value === "" ? "—" : value
}

export function normaliseHtml(value = "") {
    return normaliseText(value, { stripTags: true })
}

function formatDate(value, options) {
    if (!value) return "—"

    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return "—"

    return new Intl.DateTimeFormat("en-GB", options)
        .format(date)
        .replace(/^(\d{1,2}) ([A-Za-z]+) (\d{4}),?/, "$1 $2, $3")
        .replace(/\b(am|pm)\b/g, (match) => match.toUpperCase())
}

function decodeHtml(value) {
    const html = String(value || "")

    if (typeof document === "undefined") return html

    const decoded = document.createElement("textarea")
    decoded.innerHTML = html
    return decoded.value
}

export function normaliseText(value = "", { stripTags = false } = {}) {
    const decoded = decodeHtml(value)
    const withoutTags = stripTags ? decoded.replace(/<[^>]+>/g, " ") : decoded

    return withoutTags
        .replace(/&nbsp;|&#160;|&#xA0;|&amp;nbsp;/gi, " ")
        .replace(/\u00a0/g, " ")
        .replace(/\u200B/g, "")
        .replace(/\s+/g, " ")
        .trim()
}
